import { css } from 'aphrodite';
import { FC } from 'react';
import { LockIcon } from '../../../../components/svgs/icons/LockIcon';
import { styleSheet } from './styles';

export const SyncedCategoryLabel: FC<{ syncName: string }> = ({ syncName }) => (
	<span className={css(styleSheet.syncedCategory)}>
		<LockIcon fillColor='currentColor' />
		Kept up to date by {syncName}
	</span>
);
